import { Chip } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';
import { AccountStatus } from 'types/operations.ts';

const statusColor: Record<AccountStatus, 'success' | 'warning' | 'error'> = {
	[AccountStatus.OPENED]: 'success',
	[AccountStatus.BLOCKED]: 'warning',
	[AccountStatus.CLOSED]: 'error',
	[AccountStatus.CREDIT_BLOCKED]: 'warning',
	[AccountStatus.DEBIT_BLOCKED]: 'error',
	[AccountStatus.REJECTED]: 'error',
	[AccountStatus.WAITING_FOR_APPROVAL]: 'warning',
};

const statusMap: Record<AccountStatus, string> = {
	[AccountStatus.OPENED]: 'opened',
	[AccountStatus.BLOCKED]: 'blocked',
	[AccountStatus.CLOSED]: 'closed',
	[AccountStatus.CREDIT_BLOCKED]: 'credit_blocked',
	[AccountStatus.DEBIT_BLOCKED]: 'debit_blocked',
	[AccountStatus.REJECTED]: 'rejected',
	[AccountStatus.WAITING_FOR_APPROVAL]: 'waiting',
};

export const AccountStatusChip = ({ status }: { status: AccountStatus }) => {
	const { t } = useTranslation('', { keyPrefix: 'totalBalance' });

	return (
		<Chip
			color={statusColor[status]}
			label={t(statusMap[status])}
			size="small"
			variant="filled"
		/>
	);
};
